export default class FilterSelect {
	static init() {
		this.filters = document.querySelectorAll(".filter-select select");

		if (!this.filters.length) {
			return;
		}

		this.initFilterSelect();
	}

	static initFilterSelect() {
		this.filters.forEach(filter => {
			filter.addEventListener("change", (e) => {
				// redirect page to the selected value which should be an URL
				window.location	= e.target.value;
			});
		});
	}
}
